module.exports = __webpack_public_path__ + "static/img/video-cover-3.bfd66929.png";